import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_cash_stmt_ext_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    cash_stmt_hdr_guid: fromDatatype.VarcharDatatypeInterface;
    cash_stmt_line_guid: fromDatatype.GuidDataFieldInterface;
    ext_type: fromDatatype.VarcharDatatypeInterface;
    ext_code: fromDatatype.VarcharDatatypeInterface;
    ext_option: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;   
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    value_string: fromDatatype.VarcharDatatypeInterface;
    value_file: fromDatatype.GuidDataFieldInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime: fromDatatype.TimestampTzDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;    
}

export class bl_fi_cash_stmt_ext_RowClass implements bl_fi_cash_stmt_ext_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    cash_stmt_hdr_guid: fromDatatype.VarcharDatatypeInterface;
    cash_stmt_line_guid: fromDatatype.GuidDataFieldInterface;
    ext_type: fromDatatype.VarcharDatatypeInterface;
    ext_code: fromDatatype.VarcharDatatypeInterface;
    ext_option: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;   
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    value_string: fromDatatype.VarcharDatatypeInterface;
    value_file: fromDatatype.GuidDataFieldInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime: fromDatatype.TimestampTzDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;    
}